import { z } from "zod";

export const schema = z.object({
	id_produto: z.string().min(1, "Selecione um produto"),
	contato: z.string().min(1, "Campo contato é obrigatório"),
	nome: z.string().min(1, "Campo empresa é obrigatório"),
	telefone_1: z.string().min(1, "Campo telefone é obrigatório"),
	email: z.lazy(() => z.string().email("Digite um e-mail válido").min(1, "Campo E-mail é obrigatório")),
	senha: z.string().min(6, "Senha deve ter no mínimo 6 caracteres"),
});
